import { Box, Stack, Text } from "@mantine/core";
import ActiveCasesListQuery from "./ActiveCasesListQuery";
import ActiveCasesItem from "./ActiveCasesItem";
import classes from "../..//Home.module.css";
import { useTranslation } from "react-i18next";

export default function ActiveCasesList() {
  const { t } = useTranslation("features");

  const { cases } = ActiveCasesListQuery();

  if (cases.length == 0) {
    return (
      <Box className={classes.listContainer}>
        <Box className={classes.noListItem}>
          <Text w={"100%"} className={classes.listNoItemsText}>
            {t(`home.noActiveCases`)}
          </Text>
        </Box>
      </Box>
    );
  }

  return (
    <Stack className={classes.listContainer} gap={8}>
      {cases.map((currentCase, index) => {
        return <ActiveCasesItem key={index} currentCase={currentCase} />;
      })}
    </Stack>
  );
}
